export const capitalize = (string) => {
    if (!string) return '';
    return String(string).replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
};
